import React from "react";
import { filter } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Card,
  Table,
  Stack,
  Avatar,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
  CircularProgress,
} from "@mui/material";
import SearchNotFound from "../../components/SearchNotFound";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import {
  UserListHead,
  UserListToolbar,
} from "../../components/_dashboard/user";
import { s3baseUrl } from "../../config/config";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { DeleteMultiMemberApi } from "src/DAL/member/member";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import CustomDrawer from "src/components/DrawerForm/CustomDrawer";
import CustomPopoverSectionGroups from "src/components/MenuOption/CustomPopoverSectionGroups";
import AddGroupMembers from "src/components/CommunityGroups/AddGroupMembers";
import {
  deleteCommunityGroupMember,
  membersAddedInCommunityGroup,
} from "src/DAL/CommunityGroups/CommunityGroups";
import AddProgramMembers from "src/components/CommunityGroups/AddProgramMembers";

const TABLE_HEAD = [
  { id: "action", label: "Action", alignRight: false },
  { id: "number", label: "#", alignRight: false },
  { id: "fulName", label: "Name", alignRight: false },
  { id: "email", label: "Email", alignRight: false },
  { id: "userType", label: "Added From", alignRight: false },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (row) =>
        row.fulName.toLowerCase().indexOf(query.toLowerCase().trim()) !== -1,
    );
  }
  return stabilizedThis.map((el) => el[0]);
}
const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function GroupMembers() {
  const navigate = useNavigate();
  const path = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("number");
  const [page, setPage] = useState(0);
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [openDelete, setOpenDelete] = useState(false);
  const [openMultiDelete, setOpenMultiDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [viewDrawerOpen, setViewDrawerOpen] = useState(false);
  const classes = useStyles();
  const [deleteDoc, setDeleteDoc] = useState("");
  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const [memberFilterDrawerState, setMemberFilterDrawerState] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const EMPTY_FILTER = {
    search_text: "",
  };

  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
  };
  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  const handleOpenFilterDrawerMember = () => {
    setMemberFilterDrawerState(true);
  };

  const handleCloseFilterDrawerMember = () => {
    setMemberFilterDrawerState(false);
  };

  const params = useParams();

  const getMemberListing = async (filterData) => {
    setIsLoading(true);
    const result = await membersAddedInCommunityGroup(params?.slug);

    if (result.code == 200) {
      let chipData = { ...filterData };
      if (chipData.search_text) {
        delete chipData.search_text;
      }
      const members = result?.members?.map((member, index) => {
        return {
          ...member,
          id: member?._id?._id,
          fulName: member?._id?.first_name + " " + member?._id?.last_name,
          userType: member?.user_type,
          name: member?._id?.first_name,
          lastName: member?._id?.last_name,
          email: member?._id?.email,
          profile: member?._id?.profile_image,
          profile_image: member?._id?.profile_image,
          count: index + 1 + rowsPerPage * page,
        };
      });

      setData(members);

      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 && 0;

  const filteredUsers = applySortFilter(
    data,
    getComparator(order, orderBy),
    filterName,
  );

  const isUserNotFound = data.length === 0;

  const handleOpenViewDrawer = (row) => {
    setViewDrawerOpen(true);
  };

  const handleAgreeDelete = (value) => {
    setDeleteDoc(value);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    const newArray = { members: [{ _id: deleteDoc.id }] };
    const result = await deleteCommunityGroupMember(newArray, params.slug);
    if (result.code === 200) {
      setIsLoading(false);
      getMemberListing();
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleMultipleDelete = async () => {
    setOpenMultiDelete(false);
    const member_id = [];
    selected.map((id) => {
      member_id.push(id);
    });
    const formData = new FormData();
    formData.append("type", "specific");
    formData.append("member", JSON.stringify(member_id));
    setIsLoading(true);
    const result = await DeleteMultiMemberApi(formData);
    if (result.code === 200) {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
      setSelected([]);
      getMemberListing();
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const MENU_OPTIONS = [
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
  ];

  const MENU_OPTIONS_NEW = [
    {
      label: "Add Members",
      icon: "akar-icons:edit",
      handleClick: handleOpenFilterDrawerMember,
    },
    {
      label: "Add Members From Programme",
      icon: "ci:list-add",
      handleClick: handleOpenFilterDrawer,
    },
  ];

  useEffect(() => {
    let filter_data = EMPTY_FILTER;
    let find_filter = localStorage.getItem("MemberListSearch");
    if (find_filter) {
      filter_data = JSON.parse(find_filter);
    }
    getMemberListing(filter_data);
  }, [rowsPerPage, page]);

  useEffect(() => {
    getMemberListing(EMPTY_FILTER);
  }, []);

  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <>
      <CustomConfirmation
        open={openDelete}
        setOpen={setOpenDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handleDelete}
      />
      <CustomConfirmation
        open={openMultiDelete}
        setOpen={setOpenMultiDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handleMultipleDelete}
      />
      <div className="container">
        <div className="row mb-5">
          {path.pathname.includes("/community-area") && (
            <div className="col-12">
              <IconButton
                className="back-screen-button"
                onClick={() => navigate(-1)}
              >
                <ArrowBackIcon />
              </IconButton>
            </div>
          )}

          <div className="col-lg-6 col-sm-12">
            <h2>Community Group Members</h2>
          </div>
          <div className="col-lg-6 col-sm-12 text-end">
            <CustomPopoverSectionGroups menu={MENU_OPTIONS_NEW} data={params} />
          </div>
        </div>

        <Card style={{ overflowX: "auto" }}>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={data.length}
                numSelected={selected.length}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, i) => {
                    const { id, fulName, userType, name, email, profile } = row;
                    const isItemSelected = selected.indexOf(id) !== -1;
                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell>
                          <CustomPopoverSection
                            menu={MENU_OPTIONS}
                            data={row}
                          />
                        </TableCell>
                        <TableCell align="left">
                          {page * rowsPerPage + (i + 1)}
                        </TableCell>

                        <TableCell component="th" scope="row">
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <Avatar alt={name} src={s3baseUrl + profile} />
                            <Typography variant="subtitle2" noWrap>
                              {fulName}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell>{email}</TableCell>
                        <TableCell>
                          {userType == "program" ? "Program" : "Manually"}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={11} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={14} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 20, 50]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </div>
      <CustomDrawer
        isOpenDrawer={filterDrawerState}
        onOpenDrawer={handleOpenFilterDrawer}
        onCloseDrawer={handleCloseFilterDrawer}
        pageTitle="Add Members From Programme"
        componentToPassDown={
          <AddProgramMembers
            params={params}
            getMemberListing={getMemberListing}
            handleCloseFilterDrawer={handleCloseFilterDrawer}
          />
        }
      />
      <CustomDrawer
        isOpenDrawer={memberFilterDrawerState}
        onOpenDrawer={handleOpenFilterDrawerMember}
        onCloseDrawer={handleCloseFilterDrawerMember}
        pageTitle="Add Members"
        componentToPassDown={
          <AddGroupMembers
            params={params}
            getMemberListing={getMemberListing}
            handleCloseFilterDrawerMember={handleCloseFilterDrawerMember}
          />
        }
      />
    </>
  );
}
